import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IOption,
  VbzAnimation,
} from '@smiles/voebiz-ui-kit';
import ModalDefaultOptionList from '../../../components/ModalDefaultOptionList';
import ModalDefaultMessage from '../../../components/ModalDefaultMessage';
import { VoeBizApi } from '../../../services/services';

const formatTime = (sec: number) => {
  const pad = (num: number) => (num >= 10 ? num.toString() : `0${num}`);
  const mm = pad(Math.floor(sec / 60));
  const ss = pad(sec % 60);

  return `${mm}:${ss}`;
};

interface IPasswordFlow {
  email: string;
  tokenSmiles: string;
  open: boolean;
  onFinish: () => void;
  onClose: () => void;
}

const PasswordFlow: React.FC<IPasswordFlow> = ({
  email,
  tokenSmiles,
  open,
  onFinish,
  onClose,
}) => {
  const { t } = useTranslation('modal_forgot_password');
  const api = VoeBizApi();

  const [isOpen, setIsOpen] = useState(false);
  const [isLoadingAnimationRight, setIsLoadingAnimationRight] = useState(false);
  const [isModalSendEmail, setIsModalSendEmail] = useState(false);
  const [systemErrorNoCentral, setSystemErrorNoCentral] = useState(false);
  const [token, setToken] = useState('');

  useEffect(() => {
    if (open) {
      setIsOpen(true);
    }
  }, [open]);

  useEffect(() => {
    if (tokenSmiles) {
      setToken(tokenSmiles);
    }
  }, [tokenSmiles]);

  const handleSendEmail = useCallback(async () => {
    setIsLoadingAnimationRight(true);
    const response = await api.resetPassword(token);
    if (response.success) {
      setIsModalSendEmail(true);
    } else {
      setSystemErrorNoCentral(true);
    }
    setIsLoadingAnimationRight(false);
  }, [token]);

  const handleCentralAtendimento = () => {
    window.location.href = '/atendimento';
  };

  const options: IOption[] = useMemo(() => {
    const list: IOption[] = [];

    if (email) {
      list.push({
        id: 'lbl_email',
        labelId: 'lbl_email',
        labelSubId: 'lbl_email_sub',
        key: 'key_cpf',
        label: t('email'),
        disabled: false,
        subText: [email],
        type: 'keyboard_arrow_right',
        readonly: false,
        onClick: handleSendEmail,
      });
    }

    return list;
  }, [email, handleSendEmail]);

  return (
    <>
      <ModalDefaultOptionList
        isOpen={isOpen}
        list={options}
        translate="modal_forgot_password"
        hidePrimaryButton
        onSecondary={handleCentralAtendimento}
        toggle={() => {
          onClose();
          setIsOpen(false);
        }}
      />

      <ModalDefaultMessage
        isOpen={isModalSendEmail}
        translate="modal_forgot_password_email"
        toggle={() => setIsModalSendEmail(false)}
        onFinish={() => {
          onClose();
          setIsOpen(false);
          setIsModalSendEmail(false)
        }}
        onSecondary={handleSendEmail}
        secondaryButtonFirst={true}
      />

      <VbzAnimation
        containerIdLottie="animation-recover-password-right"
        typeModal="right"
        currentState={{
          isSuccess: true,
          isLoading: isLoadingAnimationRight,
        }}
        finishMode="no"
        message={{
          error: [],
          loading: [`${t('animation_loading')}`],
          success: [],
        }}
      />

      <ModalDefaultMessage
        isOpen={systemErrorNoCentral}
        translate="modal_system_error_no_central"
        toggle={() => window.location.reload()}
        onFinish={() => window.location.reload()}
        hideSecondaryButton
      />
    </>
  );
};

export default PasswordFlow;
